import { useTranslation } from "react-i18next";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faCalendarCheck, faNewspaper } from "@fortawesome/free-solid-svg-icons";
import ScrollToTopLink from "../ScrollToTopLink";

const Welcome = ({ sectionRef }) => {
  const { t } = useTranslation();

  return (
    <section className="hero welcome" ref={sectionRef}>
      <div className="video-background">
        <video
          src="/vid/videoPromoMMI2627.mov"
          autoPlay
          loop
          muted
          playsInline
          preload="metadata"
          poster="/img/homeBkg.jpg"
          aria-label="Video promozionale Nuova Orchestra da Camera Ferruccio Busoni"
          style={{ width: "100%", height: "100%", objectFit: "cover" }}
        />
      </div>
      <div className="video-overlay"></div>
      <div className="hero-video-overlay-content">
        <div className="container">
          <div className="row justify-content-center">
            <div className="col-12 col-xl-11 text-center">
              <h1 className="hero-video-title">
                {t("app_title", "Nuova orchestra da camera Ferruccio Busoni")}
              </h1>
              <div className="hero-video-buttons">
                <ScrollToTopLink
                  className="btn hero-btn-primary"
                  to="/concerts"
                >
                  <FontAwesomeIcon icon={faCalendarCheck} />
                  <span>{t("home.next_app", "Prossimi appuntamenti")}</span>
                </ScrollToTopLink>
                <ScrollToTopLink
                  className="btn hero-btn-secondary"
                  to="/news"
                >
                  <FontAwesomeIcon icon={faNewspaper} />
                  <span>{t("home.latest_updates", "Ultimi aggiornamenti")}</span>
                </ScrollToTopLink>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default Welcome;
